import React, { Fragment } from "react";
import { useQuery } from "react-query";

import {
  Activity,
  Bell,
  CheckCircle,
  FileText,
  UserCheck,       
} from "react-feather";
import { Link } from "react-router-dom";
import { LI, P, UL } from "../../../AbstractElements";
import { getNotifications } from "../../../MyApi/notifications";
import { Spinner } from "react-bootstrap";



const Notifications = () => {
 
   const {data ,isLoading} =useQuery("getNotifcations" ,getNotifications)

 const  notifications = data?.data || []  

 
  return (
    <Fragment>
     {isLoading ? <Spinner/> : <LI attrLI={{ className: "onhover-dropdown" }}>
        <div className="notification-box">
          <Bell />
        { notifications.length >0 && <span className="dot-animated"></span>}
        </div>
        <UL attrUL={{ className: "notification-dropdown onhover-show-div" }}>
         {!data  ||notifications.length ===0?
          <LI>
            <P attrPara={{ className: "f-w-700 m-0" }}>
              You have 0 Notifications
              <span className="pull-right badge badge-primary badge-pill">
            0
              </span>
            </P>
          </LI>
         :<>  
          {notifications.map((notify ,id)=>(
            < >
              <LI key={id}>
            <P attrPara={{ className: "f-w-700 m-0" }}> 
              You have {notifications.length} Notifications
              <span className="pull-right badge badge-primary badge-pill">
          
              </span>
            </P>
            
            </LI>
            <LI attrLI={{ className: "noti-primary" }} >
                <Link    to={`${process.env.PUBLIC_URL}/${notify.object_type}/${notify.object_id}`}    
                  
                >
                  <div className="media">
                    <span className="notification-bg bg-light-primary">
                      <Activity />
                    </span>
                    <div className="media-body">
                      <P>  {notify.name}</P>
                      <span></span>
               
                    </div>
                  </div>
                </Link>
              </LI>
       
            </>
          
                     )) } </> 
          
          
          }
       
           
      


          
        </UL>
      </LI>}
    </Fragment>
  );
};

export default Notifications;
